import { Directive, forwardRef } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';

// tslint:disable:no-forward-ref no-use-before-declare
const SKY_URL_VALIDATION_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => SkyUrlValidationDirective),
  multi: true
};
// tslint:enable


export class SkyUrlValidationDirective implements Validator {
  public validate(control: AbstractControl): {[key: string]: any} {
    const value = control.value;

    if (!value) {
      return;
    }

    if (!this.urlIsValid(value)) {
      return {
        'skyUrl': {
          invalid: control.value
        }
      };
    }
  }

  public urlIsValid(url: string): boolean {
    let regex = /^((http|https):\/\/)?([\w\-]+\.)+[\w\-]+/i;
    return regex.test(url);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[skyUrlValidation]',
  providers: [SKY_URL_VALIDATION_VALIDATOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
